import { render, staticRenderFns } from "./CatalogueTileCarousel.vue?vue&type=template&id=5c8e8158&scoped=true&"
import script from "./CatalogueTileCarousel.vue?vue&type=script&lang=js&"
export * from "./CatalogueTileCarousel.vue?vue&type=script&lang=js&"
import style0 from "./CatalogueTileCarousel.vue?vue&type=style&index=0&id=5c8e8158&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8e8158",
  null
  
)

export default component.exports